module.exports = __webpack_public_path__ + "static/media/wallpaper_small.f5af1ccc.svg";